import React from "react";
import Popup from "../Popup/Popup";

import "./ConfirmDialog.scss";

const ConfirmDialog = (props) => {

  return (
    <Popup
      title={props.title}
      confirmButton={props.confirmButton}
      cancelButton={props.cancelButton}
      onConfirm={() => props.onClose(true)}
      onCancel={() => props.onClose(false)}
      style={{width:500}}
    >
      <div className={'confirm-dialog-text'}>
        {props.children}
      </div>
    </Popup>
  );
}

export default ConfirmDialog;